module.exports = "data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAABwBACdASoCAP4BPpFIoUylpCMiIQgAsBIJaQAACLUSrzW19OnTp06dOnTfAAD++M7sAAAAAAA="